import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('carSalePopupStore', Object.keys(getters)),
	...mapState('carSalePopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('carSalePopupStore', Object.keys(actions)),
	...mapMutations('carSalePopupStore', Object.keys(mutations))
};
